/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var SettingType;
(function (SettingType) {
    SettingType["VersionYearLocks"] = "versionYearLocks";
    SettingType["FinancialYearStartingMonth"] = "financial_year_starting_month";
})(SettingType || (SettingType = {}));
export function SettingTypeFromJSON(json) {
    return SettingTypeFromJSONTyped(json, false);
}
export function SettingTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function SettingTypeToJSON(value) {
    return value;
}
